/**
 * SignupBrand — the CBOps mark for every public sign-up/auth header (Phase 2).
 *
 * Design (per layout/2-create-your-workspace-desktop.txt and the SPEC): a
 * 28x28 rounded square (radius ~8px) with a 1px teal border (#2dd4bf at ~30%),
 * a teal-tinted fill (#2dd4bf at ~10%) and a centred teal letter "C", followed
 * by the wordmark "CBOps" 17px/600 #f2f4f5 with a 10px gap.
 *
 * Drawn as an inline SVG: no existing brand component in this app renders this
 * mark (src/logo.svg is the default create-react-app React logo), so a new one
 * is drawn rather than reusing the wrong thing.
 *
 * Usage: place inside the header's brand link/span — it renders the mark and
 * the wordmark and inherits the parent's layout (gap 10px, align centre).
 */

export default function SignupBrand() {
  return (
    <>
      <svg width={28} height={28} viewBox="0 0 28 28" aria-hidden="true" focusable="false">
        <rect
          x="0.5"
          y="0.5"
          width="27"
          height="27"
          rx="8"
          fill="rgba(45, 212, 191, 0.10)"
          stroke="rgba(45, 212, 191, 0.30)"
        />
        <text
          x="14"
          y="14"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize="16"
          fontWeight="600"
          fill="#2dd4bf"
          style={{ fontFamily: 'inherit' }}
        >
          C
        </text>
      </svg>
      <span className="signup-brand__name">CBOps</span>
    </>
  );
}